// extracted by mini-css-extract-plugin
module.exports = {"notEnoughCredit":"Links_notEnoughCredit__UcrSR","upgradeButton":"Links_upgradeButton__O8iGE","link":"Links_link__0gVV8"};